import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'replaceDash'})

export class ReplaceDash implements PipeTransform {
    transform(value: string): string {
        return value.replace(/-/g, ' ');
    }
}
